<template>
    <el-dialog custom-class="validate_dialog" :model-value="show" title="定期登录验证" width="422px" destroy-on-close @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-xinxi_huaban"></i></div>
            <h1>定期登录验证</h1>
            <h2>
                我们刚刚向 <span>{{ params.loginName }}</span> 发送了一封带有 <span>验证码</span> 的电子邮件
            </h2>
            <AnimationInput v-model="codeLogin" name="validate_code" placeholder="验证码" :autoFocus="true" />
            <div class="btn_box" v-loading="loading">
                <button @click="submit">确定</button>
                <button @click="reSend">
                    重新发送<span v-if="time < duration">({{ time }})</span>
                </button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import AnimationInput from "@/components/common/AnimationInput.vue";
import { Close } from "@element-plus/icons-vue";
import { apiAuthLoginEmail, apiAuthLogin } from "@/request/api";
import { useRouter } from "vue-router";
import { setStorage } from "@/utils";

const props = defineProps({
    show: { type: Boolean, default: false },
    params: { type: Object, default: {} },
});
const emits = defineEmits(["close"]);
const router = useRouter();
const codeLogin = ref("");
const sendDis = ref(false); // 发送是否禁用
const duration = 60;
const time = ref(duration); // 倒计时
const loading = ref(false);

// 倒计时
function handleTimer() {
    sendDis.value = true;
    time.value = time.value - 1;
    if (time.value === 0) {
        time.value = duration;
        sendDis.value = false;
        return;
    }
    setTimeout(() => {
        handleTimer();
    }, 1000);
}

// 重新发送
function reSend() {
    if (sendDis.value) return;
    codeLogin.value = "";
    handleTimer();
    apiAuthLoginEmail(props.params);
}

// 提交
async function submit() {
    if (!codeLogin.value) {
        ElMessage.error("验证码不能为空");
        return;
    }
    loading.value = true;
    try {
        const { code, data } = await apiAuthLogin({ ...props.params, code: codeLogin.value });
        if (code !== "0") return;
        setStorage("token", data.token);
        setStorage("userName", data.userName);
        router.replace("/");
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {
    handleTimer();
}

// 关闭
function handleClose() {
    emits("close");
}
</script>

<style lang="scss">
.validate_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
